import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../uiClassNames';
import TextFieldStyled from './TextField.styled';

var TextField = function TextField(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var fieldClassName = useClassName('textField', className);
  return _jsx(TextFieldStyled, Object.assign({
    className: fieldClassName,
    variant: "outline",
    fullWidth: true,
    hintTooltipPlacement: "right"
  }, props));
};

export default TextField;